export default "__VITE_ASSET__O4fDJesk__"